import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function SiteFooter() {
  return (
    <footer className="mt-20 border-t border-background-300/70 bg-background-100">
      <div className="page-shell py-12 md:py-16">
        <div className="grid gap-10 md:grid-cols-12">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500 text-background-50">
                <i className="ri-book-open-line text-lg" />
              </span>
              <span className="font-heading text-[17px] font-semibold text-foreground-950">成人影视</span>
            </div>
            <p className="mt-4 max-w-sm text-[13px] leading-7 text-foreground-600">
              一个面向成年观众的影视资料与资讯平台，收录作品条目、行业动态与幕后记录，帮助你在清晰的分类体系里找到想看的内容。
            </p>
            <div className="mt-5 flex flex-wrap items-center gap-2">
              <span className="rounded-md border border-accent-300/50 bg-accent-500/10 px-2.5 py-1 font-label text-[10px] tracking-[0.16em] text-accent-400">
                18+ 仅限成年用户
              </span>
              <span className="rounded-md border border-background-300 px-2.5 py-1 font-label text-[10px] tracking-[0.16em] text-foreground-500">
                演示数据
              </span>
            </div>
          </div>

          <div className="md:col-span-3">
            <p className="eyebrow mb-4">浏览</p>
            <ul className="space-y-2.5 text-[13px]">
              {categories.slice(0, 5).map((category) => (
                <li key={category.id}>
                  <Link to={`/category/${category.id}`} className="text-foreground-600 transition-colors hover:text-primary-500">
                    {category.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-2">
            <p className="eyebrow mb-4">站点</p>
            <ul className="space-y-2.5 text-[13px]">
              <li><Link to="/" className="text-foreground-600 transition-colors hover:text-primary-500">首页</Link></li>
              <li><Link to="/search" className="text-foreground-600 transition-colors hover:text-primary-500">搜索</Link></li>
              <li><Link to="/about" className="text-foreground-600 transition-colors hover:text-primary-500">关于我们</Link></li>
              <li><Link to="/about" className="text-foreground-600 transition-colors hover:text-primary-500">联系方式</Link></li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <p className="eyebrow mb-4">声明</p>
            <p className="text-[12px] leading-6 text-foreground-500">
              本站不提供播放与下载，仅展示图文资料。所有片目与人物均为演示示例。
            </p>
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-3 border-t border-background-300/70 pt-6 text-[11px] text-foreground-500 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 成人影视 · 影视资料库　保留所有权利</p>
          <p className="leading-6">
            内容仅面向 18 岁以上成年用户，请遵守所在地法律法规 · 本站为前端演示项目
          </p>
        </div>
      </div>
    </footer>
  );
}